import { Link } from "react-router-dom";
import { Megaphone, TrendingUp } from "lucide-react";
import { useSite } from "../lib/site";
import EditPencil from "./EditPencil";

const PromoLink = ({ k, cfg, icon: Icon, cls, prefix }) => {
  const style = cfg.color ? { background: cfg.color } : {};
  const inner = <><Icon className="w-3.5 h-3.5" />{cfg.text}</>;
  const tid = `${prefix}${k}-btn`;
  return (
    <span className="relative inline-flex">
      {cfg.link.startsWith("/")
        ? <Link to={cfg.link} className={cls} style={style} data-testid={tid}>{inner}</Link>
        : <a href={cfg.link} target="_blank" rel="noopener noreferrer" className={cls} style={style} data-testid={tid}>{inner}</a>}
      <EditPencil section={k} testid={`${prefix}${k}-edit`} className="absolute -top-1.5 -right-1.5" />
    </span>
  );
};

export default function PromoButtons({ className = "", btnClass = "", prefix = "" }) {
  const { branding } = useSite();
  const cls = `btn-gold !py-1.5 !px-3 text-xs whitespace-nowrap ${btnClass}`;
  return (
    <div className={`flex gap-2 ${className}`}>
      <PromoLink k="advertise" cfg={branding.advertise} icon={Megaphone} cls={cls} prefix={prefix} />
      <PromoLink k="invest" cfg={branding.invest} icon={TrendingUp} cls={cls} prefix={prefix} />
    </div>
  );
}
